import { DateWithTimezones } from '../../../../../common/models/status-history-chain.model';
export interface ShipmentArrivalDatesModel {
  actualArrivalTime: DateWithTimezones | null;
  estimatedArrivalTime: DateWithTimezones | null;
  plannedArrivalTime: DateWithTimezones | null;
}
